import { useState } from 'react';
import { Grid, Stack, Tab, Tabs, Typography } from '@mui/material';
import { Buttons } from './base-components/buttons';
import { Chips } from './base-components/chips';
import { Colors } from './base-components/colors';
import { DsTypography } from './base-components/typography';
import { MarkdownRendererExample } from '@/components/shared/markdown-renderer/example';
import { MarkdownRendererInlineEditExample } from '@/components/shared/markdown-renderer-inline-edit/example';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { ResourceCardExamples } from '@/components/shared/resource-card/examples';
import { VideoPlayerExample } from '@/components/shared/video-player/example';
import { WizardExample } from '@/context/wizard/example';

enum TabIds {
  Base = 'base',
  Markdown = 'markdown',
  Video = 'video',
  Cards = 'cards',
  MarkdownInlineEdit = 'markdown-inline-edit',
  Wizard = 'wizard',
}

const TabsConfig = {
  [TabIds.Base]: {
    label: 'Base',
    value: TabIds.Base,
  },
  [TabIds.Markdown]: {
    label: 'Markdown',
    value: TabIds.Markdown,
  },
  [TabIds.Video]: {
    label: 'Video',
    value: TabIds.Video,
  },
  [TabIds.Cards]: {
    label: 'Cards',
    value: TabIds.Cards,
  },
  [TabIds.MarkdownInlineEdit]: {
    label: 'Markdown Inline Edit',
    value: TabIds.MarkdownInlineEdit,
  },
  [TabIds.Wizard]: {
    label: 'Wizard',
    value: TabIds.Wizard,
  },
};

export const Dev = () => {
  const [tab, setTab] = useState(TabIds.Base);

  return (
    <PageContainer>
      <PageHeader title="Dev Docs" />
      <Tabs value={tab} onChange={(_, tab) => setTab(tab)}>
        <Tab label={TabsConfig[TabIds.Base].label} value={TabIds.Base} />
        <Tab
          label={TabsConfig[TabIds.Markdown].label}
          value={TabIds.Markdown}
        />
        <Tab label={TabsConfig[TabIds.Video].label} value={TabIds.Video} />
        <Tab label={TabsConfig[TabIds.Cards].label} value={TabIds.Cards} />
        <Tab
          label={TabsConfig[TabIds.MarkdownInlineEdit].label}
          value={TabIds.MarkdownInlineEdit}
        />
        <Tab label={TabsConfig[TabIds.Wizard].label} value={TabIds.Wizard} />
      </Tabs>
      <Stack spacing={2} mt={4}>
        {tab === TabIds.Base && (
          <>
            <Typography variant="h2">Base</Typography>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Colors />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Stack spacing={4}>
                  <Buttons />
                  <DsTypography />
                  <Chips />
                </Stack>
              </Grid>
            </Grid>
          </>
        )}
        {tab === TabIds.Markdown && (
          <>
            <Typography variant="h2">Markdown</Typography>
            <MarkdownRendererExample />
          </>
        )}
        {tab === TabIds.Video && (
          <>
            <Typography variant="h2">Video</Typography>
            <VideoPlayerExample />
          </>
        )}
        {tab === TabIds.Cards && (
          <>
            <Typography variant="h2">Cards</Typography>
            <ResourceCardExamples />
          </>
        )}
        {tab === TabIds.MarkdownInlineEdit && (
          <>
            <Typography variant="h2">Markdown Inline Edit</Typography>
            <MarkdownRendererInlineEditExample />
          </>
        )}
        {tab === TabIds.Wizard && (
          <>
            <Typography variant="h2">Wizard</Typography>
            <WizardExample />
          </>
        )}
      </Stack>
    </PageContainer>
  );
};
